import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { getName } from 'country-list';

import { customerFullName } from '../../../util/utils';

const textColor = '#2A4494';

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'column',
    width: '50%'
  },
  label: {
    paddingBottom: 3,
    fontSize: 12,
    color: textColor,
    fontStyle: 'bold'
  },
  desc: {
    fontSize: 11,
    overflowWrap: 'break'
  }
});

const BillTo = ({ customer, invoice, phone }) => (
  <>
    <View style={styles.headerContainer}>
      <Text style={styles.label}>Cliente</Text>
      <Text style={styles.desc}>{customerFullName(customer)}</Text>
      {phone && (<Text style={styles.desc}>{phone}</Text>)}
      {invoice.address && (<Text style={styles.desc}>{invoice.address}</Text>)}
      {(invoice.city || invoice.state) && (
      <Text style={styles.desc}>
        {invoice.city}
        {invoice.state && `, ${invoice.state}`}
        {invoice.zip_code && `, ${invoice.zip_code}`}
      </Text>
      )}
      {invoice.country_id && (<Text style={styles.desc}>{getName(invoice.country_id)}</Text>)}
    </View>
  </>
);

export default BillTo;